module.exports = __webpack_public_path__ + "static/img/jizhong2.5cf07422.png";